import { TAB_PARAM_KEYS } from "@/constants/TabKeys";

export const INTERVENTION_SECTION_TABS_KEY = TAB_PARAM_KEYS.CONTEXT_SUBTAB_KEY;
